/**
 * @generated SignedSource<<b9acb2761014c68d29151c2b953a9631>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type helpersCheckArticleIsInSectionsArticle$data = {
  readonly sectionsV2: ReadonlyArray<{
    readonly value: ReadonlyArray<{
      readonly entityId?: string;
    } | null | undefined> | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "helpersCheckArticleIsInSectionsArticle";
};
export type helpersCheckArticleIsInSectionsArticle$key = {
  readonly " $data"?: helpersCheckArticleIsInSectionsArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpersCheckArticleIsInSectionsArticle">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "helpersCheckArticleIsInSectionsArticle"
};

(node as any).hash = "b3f53a5228dbfcce823b3e8151224e91";

export default node;
